export default "__VITE_ASSET__e011f9b3__"